import { defaultVisitTypeSchedulerConfig } from "@caredna-marlin/utils/configurationTypes";
import { sortBy, uniq } from "lodash/fp";
import { AvailabilityByTimespanQuery, CommandIndexProvidersQuery, OrgConfigQuery } from "~/graphql/__generated__/graphql";
import { OrgConfig } from "~/providers/OrgConfigProvider";

// Filter visit types by provider service lines
export const filteredProviderVisitTypes = (
  provider: CommandIndexProvidersQuery["commandIndexProviders"]["providers"][number] | undefined,
  visitTypes: Partial<OrgConfigQuery["visitType"][number][]>
) => {
  if (!provider || !visitTypes) return [];
  const providerVisitTypesIds = uniq(
    provider?.serviceLineProviders?.flatMap(
      (sl) => sl?.serviceLine?.visitTypeServiceLines.map(
        (vtsl) => vtsl.visitTypeId)
      )
    );

  return sortBy(
    "label",
    visitTypes.filter(vt => vt !== undefined)
      .filter((vt) => providerVisitTypesIds?.includes(vt?.id))
  );
}

// This function mirrors getRRuleGenerationDays in the service; they should be updated in sync if the logic changes
export const getRRuleGenerationDays = (provider: AvailabilityByTimespanQuery["provider"][number], serviceLines: OrgConfig["serviceLines"], visitTypes: OrgConfig["visitTypes"]) => {
  const providerServiceLines = provider.serviceLineProviders.map(slp => serviceLines[slp.serviceLineId])
  const providerVisitTypes = providerServiceLines.flatMap(sl => sl?.visitTypeServiceLines.map(vtsl => visitTypes[vtsl.visitTypeId]))
  const daysBeforeLastOption = providerVisitTypes.map(vt => vt?.schedulingConfig.daysBeforeLastOption ?? 0)

  return Math.max(defaultVisitTypeSchedulerConfig.daysBeforeLastOption, ...daysBeforeLastOption)
}
